import { directorApi } from '../director/directorApi'

// Белсенділік: /api/staff-activity. Поля = staffActivity.proto; idleDays null = ни разу не заходил.
// Встроено в directorApi, чтобы не трогать store.

export type SaKind = 'MENTORS' | 'HEADS'

export const SA_CATEGORIES = ['LOGIN', 'CONSPECT_CHECK', 'HOMEWORK_CHECK', 'PRACTICE_ZACHET', 'CRM_STEP', 'SALARY', 'STUDENT_VIEW', 'OTHER'] as const
export type SaCategory = (typeof SA_CATEGORIES)[number]

export interface SaRow {
    userId: number
    firstName: string
    lastName: string
    role: string
    lastActiveAt: string | null
    idleDays: number | null
    activeDays: number
    counts: Record<SaCategory, number>
    checks: number
    weekChecks: number
    inactive: boolean
    reasons: ('NO_LOGIN' | 'NO_CHECKS')[]
    pendingConspects: number
    pendingHomeworks: number
    groupCount: number
    subjects: { id: number; titleKz: string; titleRu: string }[]
}

export interface SaList {
    from: string
    to: string
    trackedSince: string | null
    rows: SaRow[]
}

export interface SaDay {
    day: string
    total: number
    counts: Record<SaCategory, number>
}

export interface SaUserDays {
    userId: number
    from: string
    to: string
    days: SaDay[]
}

export interface SaListArgs {
    kind: SaKind
    from: string
    to: string
    subjectId: number
}

export const staffActivityApi = directorApi.injectEndpoints({
    endpoints: (builder) => ({
        getStaffActivity: builder.query<SaList, SaListArgs>({
            query: (params) => ({ url: 'staff-activity', params }),
            transformResponse: (r: any) => r.data,
        }),
        getStaffActivityDays: builder.query<SaUserDays, { userId: number; from: string; to: string }>({
            query: ({ userId, from, to }) => ({ url: `staff-activity/${userId}/days`, params: { from, to } }),
            transformResponse: (r: any) => r.data,
        }),
    }),
})
